<template>
  <div>
    <div class="order-filter-card">
      <el-form :inline="true" :model="searchForm" class="filter-form">

        <el-form-item>
          <el-select v-model="searchForm.ip_type" placeholder="套餐区域" size="small" clearable>
            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.price_type" placeholder="订单类型" size="small" clearable>
            <el-option v-for="item in typeOptions1" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getData" size="small">查询</el-button>
          <el-button @click="resetForm" size="small">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="order-table-area">
      <el-table class="order-table" :data="dataSource" style="width: 100%" empty-text="暂无数据">

        <el-table-column prop="order_name" label="套餐内容" min-width="180" align="center"/>

        <el-table-column prop="paystate" label="支付状态" min-width="100" align="center">
          <template #default="{ row }">
            <span v-if="row.paystate == 1" style="color:#67c23a;">已支付</span>
            <span v-else style="color:#f56c6c;">未支付</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderstate" label="订单状态" min-width="100" align="center">
          <template #default="{ row }">
            <span v-if="row.orderstate  == 0" style="color:#67c23a;">正常</span>
            <span v-else style="color:#f56c6c;">过期</span>
          </template>
        </el-table-column>
        <el-table-column prop="createtime" label="下单时间" min-width="160" align="center">
          <template #default="{ row }">
            <span>{{ formatTime(row.createtime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="op" label="操作" min-width="100" align="center" fixed="right">
          <template #default="{ row }">
            <el-button type="text" @click="showPayDialog(row)" v-if="row.paystate == 0">支付</el-button>
            <el-button type="text" @click="submitInvoice(row)" v-if="!row.invoice">开票</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination @current-change="pageChange" :page-size="5" background layout="total,prev, pager, next"
                     :total="total"/>
    </div>


    <!-- 支付选择弹窗 -->
    <Dialog
        @confirm="confirmPay"
        ref="payMethod"
        title="订单信息"
        width="500px">
      <div class="pay-select-content">
        <div class="order-info">
          <div class="order-item" v-if="currentPayOrder">
            <div class="item-name">{{ currentPayOrder.order_name }}</div>
            <div class="item-details">
              <span>订单编号：{{ currentPayOrder.order_sn }}</span>
              <span>下单时间：{{ formatTime(currentPayOrder.createtime) }}</span>
              <span v-if="currentPayOrder.price_type == 0">订单类型：包时套餐</span>
              <span v-else-if="currentPayOrder.price_type == 1">订单类型：包量套餐</span>
              <span v-else>订单类型：商务套餐</span>
              <span v-if="currentPayOrder.ip_type == 0">套餐区域：国外</span>
              <span v-else>套餐区域：国内</span>
            </div>
          </div>
        </div>

        <div class="payment-section">
          <h3>支付方式</h3>
          <div class="payment-options">
            <div
                v-for="option in payOptions"
                :key="option.type"
                class="payment-option"
                :class="{ 'active': selectedPayType === option.type }"
                @click="selectPayType(option.type)">
              <img :src="option.icon" :alt="option.name" class="payment-icon">
              <span class="payment-name">{{ option.name }}</span>
            </div>
          </div>
        </div>
        <div class="order-amount">
          <div class="amount-label">订单金额</div>
          <div class="amount-value">¥{{ currentPayOrder ? currentPayOrder.saleamount : '0.00' }}</div>
        </div>
      </div>
    </Dialog>

    <!-- 微信支付弹窗 -->
    <Dialog title="微信扫码支付" ref="PayWatch" width="400px">
      <div style="text-align: center;">
        <div>
          <img :src="wechatQrCode" alt="微信支付二维码">
        </div>
        <p style="margin: 20px 0px">请使用微信扫描二维码完成支付</p>
      </div>
      <span slot="btn" style="display: flex;align-items: center;justify-content: center">
        <el-button @click="$refs.PayWatch.onClose()">取消</el-button>
        <el-button type="success" @click="goPayStatus">查看支付状态</el-button>
      </span>
    </Dialog>

    <!-- 支付宝支付弹窗 -->
    <Dialog title="支付宝支付" ref="PayAli" width="400px">
      <div style="text-align: center;">
        <div>
          <div>
            <img src="../assets/images/gmdl_zhifubao.png" alt=""/>
          </div>
          <p style="margin: 20px 0px">支付金额：¥{{
              currentPayOrder ? currentPayOrder.saleamount : '0.00'
            }}</p>
        </div>
      </div>

      <span slot="btn" style="display: flex;align-items: center;justify-content: center">
        <el-button @click="$refs.PayAli.onClose()">取消</el-button>
        <el-button type="primary" @click="goToAlipayPay">去支付</el-button>
        <el-button type="success" @click="goPayStatus">查看支付状态</el-button>
      </span>

    </Dialog>

    <!-- 余额支付弹窗 -->
    <Dialog title="余额支付" ref="balancePayDialog" width="400px" @confirm="onOrderPay">
      <div style="text-align: center;">
        <div style="margin: 20px 0;">
          <img src="../assets/images/balance.png" alt=""/>
        </div>
        <p style="color: #ff6b35; font-weight: bold;">支付金额：¥{{
            currentPayOrder ? currentPayOrder.saleamount : '0.00'
          }}</p>
      </div>
    </Dialog>


  </div>
</template>

<script>

import Dialog from "@/components/Dialog.vue";
import {invoice} from "@/api";

export default {
  name: 'Index',
  components: {Dialog},
  data() {
    return {
      typeOptions: [{value: '', label: '全部区域'}, {value: 0, label: '国外'}, {value: 1, label: '国内'}],
      typeOptions1: [{value: '', label: '全部类型'}, {value: 0, label: '包时套餐'}, {value: 1, label: '包量套餐'}],
      dataSource: [],
      total: 0,
      searchForm: {
        page: 1,
        order_sn: '',
        ip_type: '',
        price_type: ''
      },

      orderDetail: null,
      showToken: false,
      // 支付选择弹窗相关数据
      currentPayOrder: null,
      selectedPayType: 'balance',
      payOptions: [
        {name: '余额', icon: require('../assets/images/balance.png'), type: 'balance'},
        {name: '支付宝', icon: require('../assets/images/gmdl_zhifubao.png'), type: 'alipay'},
        {name: '微信', icon: require('../assets/images/gmdl_weixin.png'), type: 'wechat'}
      ],

      // 支付相关数据
      order_sn: '',

      // 微信支付相关
      showWechatDialog: false,
      wechatPayData: null,
      wechatQrCode: '',

      // 支付宝支付相关
      showAlipayDialog: false,
      alipayPayData: null,

      // 余额支付相关
      showBalanceDialog: false,
      balancePayData: null,
      payLoading: false,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    submitInvoice(row) {
      this.$prompt('请输入开票发送的邮箱', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: '邮箱格式不正确'
      }).then(({value}) => {
        this.$api.invoice.submitInvoice({email: value, order_sn: row.order_sn}).then(res => {
          if (res.code === 1) {
            this.$message.success(res.msg)
            this.getData()
          }
        }).finally(() => {

        })
      }).catch(() => {
      });

    },
    pageChange(e) {
      this.searchForm.page = e
      this.getData()
    },
    getData() {
      this.$api.order.getOrderList(this.searchForm).then(res => {
        this.dataSource = res.data.data
        this.total = res.data.total
      })
    },
    resetForm() {
      this.searchForm = {page: 1, order_sn: '', ip_type: '', price_type: ''};
      this.getData();
    },
    showOrderDetail(row) {
      this.showOrderDetailDialog = true;
      this.showOrderDetailLoading = true;
      this.orderDetail = null;
      this.showToken = false;
      this.$api.order.getOrderDetail({
        id: row.id
      }).then(res => {
        this.orderDetail = res.data;
        this.showOrderDetailLoading = false;
      }).catch(() => {
        this.showOrderDetailLoading = false;
      });
    },
    showWhitelist(row) {
      this.showWhitelistDialog = true;
      this.whitelistOrderSn = row.order_sn;
      this.whitelistInput = '';
      this.getWhitelist();
    },
    getWhitelist() {
      this.whitelistLoading = true;
      this.$api.order.getWhitelist({order_sn: this.whitelistOrderSn}).then(res => {
        this.whitelist = res.data.ip_white_list || [];
        this.whitelistLoading = false;
      }).catch(() => {
        this.whitelistLoading = false;
      });
    },
    submitAddWhitelist() {
      if (!this.addWhitelistForm.ip) {
        this.$message.warning('请输入IP');
        return;
      }
      // IP格式校验
      const ipReg = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;
      if (!ipReg.test(this.addWhitelistForm.ip)) {
        this.$message.warning('请输入正确的IP地址');
        return;
      }
      this.$api.order.opWhiteList({
        order_sn: this.whitelistOrderSn,
        ip: this.addWhitelistForm.ip,
        remark: this.addWhitelistForm.remark,
        op: 'add'
      }).then(() => {
        this.$message.success('添加成功');
        this.addWhitelistForm.ip = '';
        this.addWhitelistForm.remark = '';
        this.showAddWhitelistDialog = false;
        this.getWhitelist();
      });
    },
    deleteWhitelist(row) {
      this.$confirm(`确定要删除此白名单IP吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.order.opWhiteList({ip: row.white_ip, 'id': row.id, 'op': 'del', order_sn: row.order_sn}).then(() => {
          this.$message.success('删除成功');
          this.getWhitelist();
        });
      });
    },
    formatTime(ts) {
      if (!ts) return '-';
      // 支持10位和13位时间戳
      const t = ts.toString().length === 10 ? ts * 1000 : ts;
      const d = new Date(t);
      return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
    },
    closeOrderDetailDialog() {
      this.showOrderDetailDialog = false;
      this.showToken = false;
    },

    // 显示支付选择弹窗
    showPayDialog(row) {
      this.currentPayOrder = row
      this.$refs.payMethod.onOpen()
      this.selectedPayType = 'balance';
    },

    // 选择支付方式
    selectPayType(type) {
      this.selectedPayType = type;
    },

    // 确认支付
    confirmPay() {
      if (!this.currentPayOrder) {
        this.$message.error('订单信息不完整');
        return;
      }

      this.order_sn = this.currentPayOrder.order_sn;

      if (this.selectedPayType == 'balance') {
        // 余额支付，显示弹窗
        // this.showBalanceDialog = true;
        this.$refs.balancePayDialog.onOpen()
      } else if (this.selectedPayType == 'wechat') {
        this.onOrderPay();
      } else if (this.selectedPayType == 'alipay') {
        // 支付宝支付，显示弹窗
        this.onOrderPay();
      }
      this.showPaySelectDialog = false;
    },

    // 支付处理
    onOrderPay() {
      this.payLoading = true
      this.$api.order.orderPay({paytype: this.selectedPayType, order_sn: this.order_sn}).then(res => {
        if (res.data.paytype == 'balance') {
          this.$message.success('支付成功');
          this.$refs.balancePayDialog.onClose()
          this.getData(); // 刷新订单列表
        } else if (res.data.paytype == 'wechat') {
          this.showWechatPayDialog(res.data);
        } else if (res.data.paytype == 'alipay') {
          this.showAlipayPayDialog(res.data);
        }
      }).finally(() => {
        this.payLoading = false
      })
    },

    // 显示微信支付弹窗
    showWechatPayDialog(payData) {
      // 获取二维码数据，支持多种字段名和base64格式
      let qrCodeData = payData.wechat_data || payData.qr_code || payData.qrcode || payData.qrCode || ''

      // 如果是base64格式，需要添加data:image前缀
      if (qrCodeData && !qrCodeData.startsWith('data:image') && !qrCodeData.startsWith('http')) {
        // 假设返回的是纯base64数据，添加图片前缀
        qrCodeData = `data:image/png;base64,${qrCodeData}`
      }

      // 设置微信支付弹窗数据
      this.wechatPayData = payData;
      this.wechatQrCode = qrCodeData;
      this.$refs.PayWatch.onOpen()
    },

    // 显示支付宝支付弹窗
    showAlipayPayDialog(payData) {
      // 设置支付宝支付弹窗数据
      this.alipayPayData = payData;
      this.$refs.PayAli.onOpen()
    },

    // 支付宝支付弹窗按钮处理方法
    goToAlipayPay() {
      this.redirectToAlipay(this.alipayPayData);
    },

    // 查看支付状态
    goPayStatus() {
      this.$router.push({
        path: '/pay-status',
        query: {order_sn: this.order_sn, type: 'orderpay'}
      });
    },

    // 跳转到支付宝支付
    redirectToAlipay(payData) {
      if (payData.alipay_data) {
        // 如果有HTML内容，打开新窗口
        const newWindow = window.open()
        newWindow.document.write(payData.alipay_data)
        newWindow.document.close()
      } else if (payData.redirect_url) {
        // 如果有重定向URL，直接跳转
        window.location.href = payData.redirect_url
      } else {
        this.$message.error('支付宝支付链接获取失败')
      }
    }
  }
}
</script>

<style scoped>
.order-filter-card {
  background: #fff;
  box-shadow: 0 4px 24px rgba(38, 130, 255, 0.08);
  padding: 24px 24px 0 24px;
  margin-top: 20px;
}


.order-table-area {
  min-height: 320px;
  background: #fff;
  margin-top: 0;
  box-shadow: none;
}

.order-table {
  border-radius: 0;
  overflow: hidden;
  box-shadow: none;
}

.order-table ::v-deep tr th {
  background: #f5f7fa;
  color: #222;
  font-weight: 600;
  font-size: 15px;
}

.order-table ::v-deep tr {
  transition: background 0.2s;
}

.order-table ::v-deep tr:hover td {
  background: #f0f7ff;
}

.order-table ::v-deep td,
.order-table ::v-deep th {
  padding: 12px 0;
  height: 48px;
  line-height: 24px;
}

.pagination {
  margin-top: 18px;
  text-align: right;
  padding-bottom: 18px;
}


.el-pagination .el-pager li.active {
  background: #2682ff;
  color: #fff;
  border-radius: 0;
}


.money-strong {
  color: #e67e22;
  font-size: 15px;
}

.order-detail-loading {
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.order-detail-loading .el-icon-loading {
  font-size: 32px;
  color: #409EFF;
}

.order-detail-loading .loading-text {
  margin-top: 10px;
  font-size: 14px;
  color: #409EFF;
  letter-spacing: 1px;
}


.pay-select-content {
  padding: 0;
}

.order-info {
  margin-bottom: 30px;
}

.order-info h3 {
  color: #183e7c;
  font-size: 18px;
  margin-bottom: 15px;
  font-weight: 600;
}

.order-item {
  padding: 5px;
}

.item-name {
  color: #2682ff;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}

.item-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.item-details span {
  color: #666;
  font-size: 14px;
}

.payment-section {
  margin-bottom: 30px;
}

.payment-section h3 {
  color: #183e7c;
  font-size: 18px;
  margin-bottom: 15px;
  font-weight: 600;
}

.payment-options {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.payment-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
}

.payment-option:hover {
  border-color: #2682ff;
  background: #f8f9ff;
}

.payment-option.active {
  border-color: #2682ff;
  background: #e9efff;
}

.payment-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.payment-name {
  color: #333;
  font-size: 14px;
  font-weight: 500;
}

.order-amount {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.amount-label {
  color: #666;
  font-size: 16px;
  font-weight: 500;
}

.amount-value {
  color: #ff6b35;
  font-size: 24px;
  font-weight: 700;
}


</style>
